export default "__VITE_ASSET___rGYgYZp__"